module.exports = __webpack_public_path__ + "img/marker_secondary.6068d958.svg";